import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import BaseSettingCard from '@dashboard/components/platform-settings/BaseSettingCard';
import { useRequestPlatformDeleteMutation } from '@dashboard/generated/wp/platform';
import { Alert, Button, Typography } from '@mui/material';

import { alertSuccess } from '@waypoint/react/notifications';

export default function PlatformDeletePage() {
  const [confirmationText, setConfirmationText] = useState('');
  const deleteEnabled = confirmationText === 'delete platform';
  const navigate = useNavigate();
  const [executeMutation, { loading }] = useRequestPlatformDeleteMutation();

  const onDeleteClick = async () => {
    if (!deleteEnabled) {
      return;
    }

    await executeMutation();
    alertSuccess('Workspace deletion requested');
    navigate('/');
  };
  return (
    <BaseSettingCard title="Delete Workspace">
      <Alert severity="warning" sx={{ mb: 2 }}>
        <Typography>
          Deleting a workspace is irreversible. All data associated with this workspace will be permanently removed.
        </Typography>
      </Alert>

      <Typography sx={{ mb: 2 }}>
        To confirm the deletion of this workspace, please type <strong>delete platform</strong> in the box below:
      </Typography>
      <input
        type="text"
        value={confirmationText}
        disabled={loading}
        onChange={(e) => setConfirmationText(e.target.value)}
        style={{ width: '100%', padding: '8px', marginBottom: '16px', boxSizing: 'border-box' }}
      />
      <Button variant="contained" color="error" disabled={!deleteEnabled || loading} onClick={onDeleteClick}>
        Delete Workspace
      </Button>
    </BaseSettingCard>
  );
}
